import { Heading } from '@chakra-ui/react';

export function FormPanelHeading({ children }: { children: React.ReactNode }) {
  return (
    <Heading
      as="h2"
      display="inline-block"
      ml={4}
      px={2}
      fontWeight="semibold"
      fontSize="16px"
      lineHeight="24px"
      bg="white"
      transform="translateY(-50%)"
    >
      {children}
    </Heading>
  );
}
